import { emitNotificationFromApi, useNotificationsStore } from '../stores/notificationsStore';
import { API_BASE } from '../config/env';

declare global {
  interface Window {
    __neoemr_notifications_fetch_wrapped__?: boolean;
  }
}

function extractPath(input: RequestInfo | URL): string | null {
  try {
    if (typeof input === 'string') {
      const asUrl = new URL(input, window.location.origin);
      return asUrl.pathname + asUrl.search;
    }
    if (input instanceof URL) {
      return input.pathname + input.search;
    }
    if (typeof Request !== 'undefined' && input instanceof Request) {
      const asUrl = new URL(input.url, window.location.origin);
      return asUrl.pathname + asUrl.search;
    }
  } catch {
    return null;
  }
  return null;
}

function isApiCall(path: string, apiBase: string) {
  try {
    const basePath = new URL(apiBase, window.location.origin).pathname || '';
    if (!basePath || basePath === '/') return true;
    return path.startsWith(basePath);
  } catch {
    return true;
  }
}

export function installNotificationsFetchBridge() {
  if (typeof window === 'undefined') return;
  if (window.__neoemr_notifications_fetch_wrapped__) return;

  useNotificationsStore.getState().hydrate();

  const apiBase = API_BASE;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const method = String(init?.method || (typeof Request !== 'undefined' && input instanceof Request ? input.method : 'GET') || 'GET').toUpperCase();
    const path = extractPath(input);
    const response = await originalFetch(input, init);

    if (path && isApiCall(path, apiBase)) {
      emitNotificationFromApi(path, method, response.ok, response.status);
    }

    return response;
  };

  window.__neoemr_notifications_fetch_wrapped__ = true;
}

